import { postData } from '../api-client';
import { CONNECT_CAMPUS, FEED } from '../../shared/constants/routing-constants';


export function postCampusConnect(jsonData: any) {
  return postData(`${FEED}/${CONNECT_CAMPUS}`, jsonData);
}